"use client";
import { GoogleTagManager } from "@next/third-parties/google";
import { MixpanelProvider } from "./MixpanelProvider";
import { HotjarProvider } from "./HotjarProvider";
import { EverflowScript } from "@portal/app/_components/scripts/EverflowScript";
import { JornayaScript } from "@portal/app/_components/scripts/JornayaScript";
import { CookieYesScript } from "../scripts/CookieYesScript";

import { GoogleAdsAttributionScript } from "../scripts/GoogleAdsAttributionScript";

import { Ga4SessionCaptureScript } from "../scripts/Ga4SessionCaptureScript";

const gtmContainer = process.env.GOOGLE_TAG_MANAGER_CONTAINER_ID ?? "";
const gtmAuth = process.env.GOOGLE_TAG_MANAGER_AUTH;
const gtmEnvironment = process.env.GOOGLE_TAG_MANAGER_ENVIRONMENT_ID;

export const AnalyticsProvider = ({
  children,
  isPreview = false,
  trackingScriptsEnabled = true,
}: React.PropsWithChildren<{
  isPreview?: boolean;
  /**
   * Mount auxiliary tracking scripts and CookieYes; Mixpanel remains available.
   * Controls mounting only, not revocation or cleanup of already loaded scripts.
   */
  trackingScriptsEnabled?: boolean;
}>) => {
  return (
    <>
      {/*
        Not a tag: it only copies gclid/wbraid/gbraid from the URL into a first-party
        cookie, so it needs no consent default and must keep running on the error
        fallback, where the gated scripts below are dropped (ENG-11022).
      */}
      <GoogleAdsAttributionScript />
      {trackingScriptsEnabled && (
        <>
          <Ga4SessionCaptureScript />
          <HotjarProvider />
          <GoogleTagManager gtmId={gtmContainer} auth={gtmAuth} preview={gtmEnvironment} />
          <EverflowScript />
          {/*
            Jornaya stays sitewide instead of route-gating by /flows, /school, or
            DreamSearch. Users can move between these surfaces before a lead path
            is known. Its necessary lead-ID capture does not depend on CookieYes.
            Persistence happens on lead/clickout submission paths that read the token.
          */}
          <JornayaScript />
        </>
      )}
      <MixpanelProvider isPreview={isPreview}>
        {trackingScriptsEnabled && <CookieYesScript />}
        {children}
      </MixpanelProvider>
    </>
  );
};
